import React from "react";
import "./Customer.css";
import { distanceAmountCalculation } from "../../utils/Utils";

const DisplayOrder = ({
  name = "",
  email = "",
  mobile = "",
  pickupDate = "",
  pickupLocationDetails = "",
  dropLocationDetails = "",
  serviceLiftAtPickup = true,
  serviceLiftAtDrop = true,
  addOns = {
    singleLayerPacking: "",
    multiLayerPacking: "",
    unpacking: "",
    dismantling: "",
  },
  furnitures = [],
  totalCost = 0,
  showPrice = true,
  housingType = "",
  loadType = "",
  additionalItems = "",
  distanceConfig = {
    _id: "",
    minDistance: 0,
    minCharge: 0,
    extraChargePerKM: 0,
  },
  distance,
}) => {
  return (
    <div className="container">
      <div className="header">
        <h1>Moving Details</h1>
      </div>
      <div className="details">
        <p>
          <strong>Name:</strong> {name}
        </p>
        <p>
          <strong>Email:</strong> {email}
        </p>
        <p>
          <strong>Mobile:</strong> {mobile}
        </p>
        <p>
          <strong>Date:</strong> {pickupDate}
        </p>
        <p>
          <strong>Pickup Location:</strong>{" "}
          {pickupLocationDetails.pickupLocation} (Floor{" "}
          {pickupLocationDetails.pickupFloor})
        </p>
        <p>
          <strong>Drop Location:</strong> {dropLocationDetails.dropLocation}{" "}
          (Floor {dropLocationDetails.dropFloor})
        </p>
      </div>
      <div className="lifts">
        <h2>Service Lift Availability</h2>
        <p>
          <strong>Service Lift at Pickup Location:</strong>{" "}
          {serviceLiftAtPickup ? "Available" : "Not Available"}
        </p>
        <p>
          <strong>Service Lift at Drop Location:</strong>{" "}
          {serviceLiftAtDrop ? "Available" : "Not Available"}
        </p>
      </div>
      {loadType !== "" && (
        <div className="lifts">
          <p>
            <strong>Load Type:</strong> {loadType}
          </p>
        </div>
      )}
      {housingType !== "" && (
        <div className="lifts">
          <p>
            <strong>Housing type:</strong> {housingType ?? ""}
          </p>
        </div>
      )}
      {additionalItems !== "" && (
        <div className="lifts">
          <p>
            <strong>Additional Items:</strong> {additionalItems ?? ""}
          </p>
        </div>
      )}
      <p>
        <strong>Add-Ons:</strong>
      </p>
      <ul>
        {addOns.singleLayerPacking && (
          <li>Single Layer Packing{" - ₹799"}</li>
        )}
        {addOns.multiLayerPacking && (
          <li>Multi Layer Packing{ " - ₹1,599"}</li>
        )}
        {addOns.unpacking && <li>Unpacking{" - ₹799"}</li>}
        {addOns.dismantling && <li>Dismantling{" - ₹799"}</li>}
      </ul>
      <p>
        <strong>Distance:</strong> {distance}
        {" km"}
      </p>
      <p>
        <strong>Distance Cost:</strong> ₹{distanceAmountCalculation(distance, distanceConfig)}
      </p>
      {!serviceLiftAtPickup && pickupLocationDetails.pickupFloor > 1 && (
        <p>
          <strong>Pickup Floor Cost:</strong> ₹1500
        </p>
      )}
      {!serviceLiftAtDrop && dropLocationDetails.dropFloor > 1 && (
        <p>
          <strong>Drop Floor Cost:</strong> ₹1500
        </p>
      )}
      <div className="furnitures">
        <h2>Furnitures</h2>
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Quantity</th>
              {showPrice && <th>Price</th>}
              {showPrice && <th>Total Price</th>}
            </tr>
          </thead>
          <tbody>
            {furnitures.length > 0 &&
              furnitures.map((item, index) => (
                <tr key={index}>
                  <td>{item.name}</td>
                  <td>{item.quantity}</td>
                  {showPrice && <td>{item.price}</td>}
                  {showPrice && <td>{item.price * item.quantity}</td>}
                </tr>
              ))}
          </tbody>
          <tfoot>
            <tr className="total">
              <td colSpan={"3"}>Total</td>
                <td className="total-price">
                  ₹{totalCost}
                </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};

export default DisplayOrder;
